// src/components/AppHeader.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // or '../assets/logo.svg'

/**
 * Props:
 * - title: string (required)
 * - subtitle?: string
 * - toHomeOnLogo?: boolean (default: true)
 */
const AppHeader = ({ title, subtitle, toHomeOnLogo = true }) => {
  return (
    <div className="relative bg-gradient-to-b from-app-bg-secondary-light to-app-bg-light dark:from-app-bg-secondary dark:to-app-nav border-b border-app-border-light dark:border-app-border shadow-lg lg:hidden">
      <div className="relative px-4 py-2 flex items-center">
        {/* Logo - Left aligned */}
        {toHomeOnLogo ? (
          <Link
            to="/"
            className="flex-shrink-0 transition-transform hover:scale-105 active:scale-95 relative z-10"
          >
            <img
              src={logo}
              alt="SelfDrive"
              className="h-12 w-auto select-none object-contain"
              style={{ filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3))' }}
              draggable="false"
            />
          </Link>
        ) : (
          <div className="flex-shrink-0 relative z-10">
            <img
              src={logo}
              alt="SelfDrive"
              className="h-12 w-auto select-none object-contain"
              style={{ filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3))' }}
              draggable="false"
            />
          </div>
        )}

        {/* Title and Subtitle - Centered */}
        <div className="absolute left-0 right-0 flex flex-col items-center justify-center pointer-events-none">
          <h1 className="text-xl font-bold tracking-tight text-app-text-light dark:text-app-text">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-app-text-secondary-light dark:text-app-text-secondary font-light">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-yellow-500 to-transparent opacity-50"></div>
    </div>
  );
};

export default AppHeader;
